import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy, ViewChild, HostListener, ElementRef } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { ThemeService } from '../theme.service';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent extends BaseComponent implements OnInit {

  @Input() title = "";
  @Input() items = [];
  @Input() selectedItem;
  @Input() right;
  @Input() selectedItemWidth = "";
  @Input() label = "";
  @Input() default;
  @Input() alignLeft: boolean = false;
  @Input() translationKeyOverrides: { [key: string]: string } = {};

  //Used to specify what attribute of the item object should be used for display
  @Input() stringAttr = null;
  @Input() stringAttrIntl = false;

  @ViewChild('dropdownContent', {static: false}) dropdownContent;

  @Output() onItemSelected = new EventEmitter();

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.closeDropdown();
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    private elementRef: ElementRef,
    private themeService: ThemeService
    ) {
    super();
  }

  ngOnInit() {
  }

  select(item){

    this.closeDropdown();

    this.onItemSelected.emit(item);
    this.selectedItem = item;
  }

  getRight(): boolean {
    return this.right;
  }

  getItemString(item): string{
    if (item){
      if (this.stringAttr){
        if (this.stringAttrIntl) {
          return this.getString(item[this.stringAttr]);
        }
        return item[this.stringAttr];
      }
      else {
        if (this.translationKeyOverrides && this.translationKeyOverrides[item]) {
          return this.getString(this.translationKeyOverrides[item]);
        }
        return this.getString(item);
      }
    }
    return "";
  }

  dropdownClick() {

    if (this.dropdownContent && this.dropdownContent.nativeElement.classList.contains("dd-open")) {
      this.closeDropdown();
    }
    else {
      this.openDropdown();
    }
  }

  closeDropdown() {
    if(this.dropdownContent) {
      this.dropdownContent.nativeElement.className = "dropdown-content dd-close";
    }
  }

  openDropdown() {
    if(this.dropdownContent) {
      this.dropdownContent.nativeElement.className = "dropdown-content dd-open";
    }
  }

  shouldBeRed(): boolean {
    let returnValue;
    if (!this.default || !this.selectedItem) {
      returnValue = false;
    }
    else if (this.default instanceof Object) {
      returnValue = this.default.type != this.selectedItem.type;
    }
    else {
      returnValue = this.default != this.selectedItem;
    }

    return returnValue;

  }

  getDownTriangleSrc(): string {
    return this.themeService.isDarkTheme() ? "./assets/images/white_down_triangle.png" : "./assets/images/black_down_triangle.png";
  }

}
